
export interface BindingInfo {
  path:string
  groupPath:string
  memberKey:string
  iterable:boolean
  group: () => BindingInfo[]
  record: (tableData:any) => {[key:string]:any}
  data: (tableData:any) => any
  upperGroups: () => BindingInfo[]
  row:number
  col:number
}

export const parseBindingPaths = (paths:string[]):BindingInfo[][] => {
  const results:BindingInfo[][] = []
  const bindingGroups:{[key:string]: BindingInfo[]} = {}

  paths.forEach(path => {
    const tokens = path.split('|')
    const rowNum = Number(tokens[0])
    const colNum = Number(tokens[1])
    const bindPath = tokens.slice(2).filter(it => !!it).join('.')
    const segments = bindPath.split('.')
    const segmentsLength = segments.length
    const groupPath = !segmentsLength ? '' : segments.slice(0, segmentsLength-1).join('.')
    const memberKey = segments[segmentsLength-1]

    let row = results[rowNum]
    if (!row) {
      row = []
      results[rowNum] = row
    }
    let group = bindingGroups[groupPath]
    if (!group) {
      group = []
      bindingGroups[groupPath] = group
    }
    const bindingInfo = {
      path: bindPath,
      groupPath: groupPath,
      iterable: /^.*\.[0-9]+$/.test(groupPath),
      memberKey: memberKey,
      row: rowNum,
      col: colNum,
      group: () => bindingGroups[groupPath],
      data: (tableData) => tableData[rowNum][colNum],
      record: (tableData) => {
        const result = {}
        bindingGroups[groupPath].forEach(item => {
          result[item.memberKey] = tableData[item.row][item.col];
        })
        return result
      },
      upperGroups: () => {
        return [].concat(
          ...Object.keys(bindingGroups)
                   .filter(k => groupPath.startsWith(k + '.'))
                   .map(k => bindingGroups[k])
        )
      },
    }
    row[colNum] = bindingInfo
    group.push(bindingInfo)
  })
  return results
}



// WEBPACK FOOTER //
// ./src/widgets/spread_sheet/binding.ts